export default __webpack_public_path__ + "static/media/pinterest_logo.05079f5d.svg";